var _a;
import { Inertia } from '@inertiajs/inertia';
export default class PageExitConfirm {
    static leavedConfirm(event) {
        event.returnValue = PageExitConfirm._message;
    }
    static historyBackConfirm(event) {
        if (!confirm(this._message)) {
            history.pushState(null, '', null);
            event === null || event === void 0 ? void 0 : event.preventDefault();
        }
    }
}
_a = PageExitConfirm;
// Inertiaのイベント解除用の関数を格納する
PageExitConfirm.voidFunc = () => { };
// イベント設定フラグ
PageExitConfirm.ready = false;
PageExitConfirm._message = 'このページを離れても大丈夫ですか？';
PageExitConfirm.addEvent = () => {
    // 既にイベントが設定されていたら以降の処理を行わない
    if (_a.ready)
        return;
    _a.ready = true;
    // window.addEventListener('beforeunload', this.leavedConfirm);
    window.addEventListener('popstate', _a.historyBackConfirm);
    Inertia.on('success', (response) => {
        response.preventDefault();
    });
    _a.voidFunc = Inertia.on('before', event => {
        return confirm(PageExitConfirm._message);
    });
};
PageExitConfirm.removeEvent = () => {
    // window.removeEventListener('beforeunload', this.leavedConfirm);
    window.removeEventListener('popstate', _a.historyBackConfirm);
    if (_a.voidFunc)
        _a.voidFunc();
    _a.ready = false;
};
